import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Link, Typography, Divider, Grid, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

export function ValidationError(props) {
    const [reasonText, setReasonText] = useState(null);

    const history = useHistory();
    //Get reason for invalid
    const value = queryString.parse(window.location.search);
    const reason = value.reason;

    useEffect(() => {
        switch (reason) {
            case "notFound":
                setReasonText({
                    title: "We could not find you using your details.",
                    explanation:
                        "Using the details you provided we are unable to find you, please try again and ensure that the details you are entering are the same details your GP will have on record.",
                });
                break;

            case "error":
                setReasonText({
                    title: "An error occurred during your validation, please try again.",
                    explanation:
                        "Please ensure that the details you are entering are the same details your GP will have on record.",
                });
                break;

            default:
                setReasonText({
                    title: "An error occurred during your validation, please try again.",
                    explanation:
                        "Please ensure that the details you are entering are the same details your GP will have on record.",
                });
                break;
        }
    }, []);

    return (
        <Grid container align="center" alignItems="center" justifyContent="center" direction="column">
            {reasonText != null && (
                <Alert
                    severity="error"
                    variant="filled"
                    sx={{
                        mt: {
                            xs: 3,
                            sm: 2,
                        },
                        mb: 2,
                        maxWidth: "md",
                    }}
                >
                    <AlertTitle>{reasonText["title"]}</AlertTitle>
                    <br />
                    <Typography> {reasonText["explanation"]}</Typography>
                    <br />
                    <br />
                    <Divider />
                    <br />
                    <Typography>
                        {" "}
                        If you need to contact us please visit -{" "}
                        <Link
                            href="https://www.connecthealth.co.uk/patient-information/"
                            target="_blank"
                            rel="noopener"
                            color="inherit"
                            underline="always"
                        >
                            https://www.connecthealth.co.uk/patient-information/
                        </Link>
                    </Typography>
                    <Typography>
                        You will also find information about your service, including opening times, services offered and
                        who your clinicians are, on our website.
                    </Typography>
                    <br />
                    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ maxWidth: "md" }}>
                        <Button
                            sx={{ margin: "40px 0px 10px 10px" }}
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={history.goBack}
                        >
                            {"Try again"}
                        </Button>
                    </Grid>
                </Alert>
            )}
        </Grid>
    );
}
